import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function PrixInterventionNuisibles() {
  const post = getPostBySlug("prix-intervention-anti-nuisibles-creuse");
  return (
    <BlogPostLayout post={post}>
      <p>
        « Combien coûte une intervention anti-nuisibles en Creuse ? » C'est la
        première question que se posent nos clients. Voici la{" "}
        <strong>grille tarifaire honnête et détaillée</strong> pratiquée par
        K'REUSE EXTÉRIEUR — sans surprise, sans devis flou, sans coût caché.
      </p>

      <h2>Frelons et guêpes : destruction de nid</h2>
      <table>
        <thead>
          <tr>
            <th>Type d'intervention</th>
            <th>Tarif</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Nid de guêpes accessible ({'<'} 4 m)</td>
            <td>90-130 €</td>
          </tr>
          <tr>
            <td>Nid de frelons européens</td>
            <td>110-160 €</td>
          </tr>
          <tr>
            <td>Nid de frelons asiatiques (perche télescopique)</td>
            <td>130-220 €</td>
          </tr>
          <tr>
            <td>Nid en hauteur ({'>'}  15 m, nacelle)</td>
            <td>250-400 €</td>
          </tr>
          <tr>
            <td>Nid primaire (avril-juin, orange)</td>
            <td>70-100 €</td>
          </tr>
        </tbody>
      </table>

      <div className="callout">
        <strong>Astuce économique</strong>
        Faire détruire un nid primaire (avril-juin) coûte 2 à 3× moins cher
        qu'un nid secondaire (juillet-octobre) — et évite qu'il devienne un
        nid dangereux. Si vous voyez un petit nid en début de saison :
        agissez tôt.
      </div>

      <h2>Dératisation (rats, souris, loirs)</h2>
      <table>
        <thead>
          <tr>
            <th>Intervention</th>
            <th>Tarif</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Diagnostic + traitement ponctuel maison</td>
            <td>150-250 €</td>
          </tr>
          <tr>
            <td>Traitement dépendances (grange, garage, poulailler)</td>
            <td>200-350 €</td>
          </tr>
          <tr>
            <td>Contrat annuel maison individuelle (2-4 visites)</td>
            <td>250-400 €/an</td>
          </tr>
          <tr>
            <td>Contrat annuel gîte / chambre d'hôtes</td>
            <td>400-700 €/an</td>
          </tr>
          <tr>
            <td>Contrat annuel exploitation agricole</td>
            <td>Sur devis</td>
          </tr>
        </tbody>
      </table>

      <h2>Punaises de lit</h2>
      <table>
        <thead>
          <tr>
            <th>Surface</th>
            <th>Tarif</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Studio / chambre isolée</td>
            <td>150-250 €</td>
          </tr>
          <tr>
            <td>Appartement T2-T3</td>
            <td>250-450 €</td>
          </tr>
          <tr>
            <td>Maison ou grand appartement</td>
            <td>400-700 €</td>
          </tr>
          <tr>
            <td>Gîte ou hôtel (par chambre)</td>
            <td>200-350 €</td>
          </tr>
        </tbody>
      </table>
      <p>
        Le tarif inclut le diagnostic, le traitement complet (vapeur sèche +
        biocide si nécessaire), un 2ème passage à J+14, et le contrôle final à
        J+28. Voir notre page{" "}
        <Link to="/punaises-de-lit-creuse">
          traitement punaises de lit Creuse
        </Link>.
      </p>

      <h2>Cafards, blattes, fourmis</h2>
      <ul>
        <li>Cuisine standard : <strong>100-200 €</strong></li>
        <li>Appartement complet : <strong>200-350 €</strong></li>
        <li>Restaurant / cuisine professionnelle : <strong>350-800 €</strong></li>
        <li>Fourmis (traitement source + trajets) : <strong>90-180 €</strong></li>
      </ul>

      <h2>Chenilles processionnaires</h2>
      <ul>
        <li>Pose éco-piège à collier (par pin) : <strong>60-90 €</strong></li>
        <li>Échenillage manuel (nid en hauteur) : <strong>130-250 €</strong></li>
        <li>Traitement d'un jardin complet : sur devis</li>
      </ul>

      <h2>Désinfection professionnelle</h2>
      <ul>
        <li>Désinfection matelas + sommier : <strong>90-150 €</strong></li>
        <li>Studio complet après sinistre : <strong>250-500 €</strong></li>
        <li>Logement de 100 m² : <strong>600-1500 €</strong></li>
        <li>Local pro / restaurant : sur devis (avec certificat HACCP)</li>
      </ul>

      <h2>Ce qui influence le tarif</h2>
      <ol>
        <li>
          <strong>Type de nuisible et ampleur de l'infestation</strong> — un
          nid isolé vs une infestation généralisée diffèrent en temps et
          produit.
        </li>
        <li>
          <strong>Hauteur et accessibilité</strong> — un nid à 15 m avec
          nacelle coûte 2-3× plus qu'un nid à 4 m.
        </li>
        <li>
          <strong>Superficie</strong> — pour désinsectisation et
          désinfection, le tarif est proportionnel à la surface traitée.
        </li>
        <li>
          <strong>Urgence</strong> — intervention le jour même ou le week-end
          peut inclure une majoration de 20-30 %.
        </li>
        <li>
          <strong>Contrat annuel</strong> — les contrats de prévention
          offrent 15-25 % d'économie par rapport à des interventions
          ponctuelles cumulées.
        </li>
      </ol>

      <h2>Ce qui est TOUJOURS inclus dans nos tarifs</h2>
      <ul>
        <li>Diagnostic gratuit sur place ou par photo</li>
        <li>Devis écrit détaillé avant intervention</li>
        <li>Déplacement dans toute la Creuse (aucun frais additionnel)</li>
        <li>Certification Certibiocide et respect des dosages réglementaires</li>
        <li>Attestation d'intervention (utile pour bailleurs / HACCP)</li>
        <li>Facture avec TVA</li>
        <li>Suivi post-intervention selon le protocole</li>
      </ul>

      <h2>Attention aux tarifs "trop beaux pour être vrais"</h2>
      <p>
        Méfiez-vous des offres à 50 € pour un nid de frelons ou 80 € pour un
        traitement anti-punaises complet. Ces prix cachent presque toujours :
      </p>
      <ul>
        <li>Une intervention incomplète (traitement partiel)</li>
        <li>Une absence de certification Certibiocide (illégal)</li>
        <li>Des surfacturations cachées ("mais le nid était plus haut que prévu…")</li>
        <li>Aucune garantie de résultat</li>
      </ul>
      <p>
        Un devis clair et une entreprise certifiée sont l'assurance d'un
        résultat durable.
      </p>

      <h2>Comment obtenir un devis ?</h2>
      <ol>
        <li>
          <strong>Envoyez-nous une photo</strong> par WhatsApp (07 80 54 11
          15) ou par le{" "}
          <Link to="/#contact">formulaire de contact</Link>.
        </li>
        <li>
          <strong>Nous vous rappelons sous 24 h</strong> avec une estimation
          tarifaire et un rendez-vous d'intervention.
        </li>
        <li>
          <strong>Devis définitif sur place</strong> avant tout démarrage. Vous
          êtes libre d'accepter ou de refuser.
        </li>
      </ol>

      <h2>Pour aller plus loin</h2>
      <p>
        Consultez notre{" "}
        <Link to="/entreprise-nuisibles-creuse">
          page anti-nuisibles Creuse
        </Link>{" "}
        pour la liste complète de nos services et zones d'intervention.
      </p>
    </BlogPostLayout>
  );
}
